// extracted by mini-css-extract-plugin
module.exports = {"history":"RequestShipHistory_history__2PX74"};